<div class="modal-header">
    <h6 class="modal-title pull-left">Upload File</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')" >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
              <div class="input-group">
                <div class="custom-file">
                <input type="file" class="custom-file-input" id="exampleInputFile" accept=".csv" (change)="selectFile($event,'csv')">
                <label class="custom-file-label" for="exampleInputFile">{{ selectedFileName || 'Choose file' }}</label>
                </div>
                </div>
                <!-- <label for="ID">Upload Csv</label>
                <input type="file" id="uploadMeta" class="form-control"  accept=".csv" #eventImg placeholder="Add Photo" (change)="selectFile($event,'csv')" > -->
            </div>
        </div>
    </div>
  </div>
<div class="modal-footer">
 <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()" >Cancel</button>&nbsp;
    <button [disabled]="is_save" type="button" class="btn btn-primary btn-sm"  (click)="save()" >Save</button>
    <!--  [attr.disabled]="isloaded==1 ? 'disabled' : null" -->
</div> 